import { render, staticRenderFns } from "./AttachmentDate.vue?vue&type=template&id=33647fc7&scoped=true"
import script from "./AttachmentDate.vue?vue&type=script&lang=ts"
export * from "./AttachmentDate.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentDate.vue?vue&type=style&index=0&id=33647fc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33647fc7",
  null
  
)

export default component.exports